import {defineAsyncComponent} from 'vue'

const CpeBudgetsChilrensRouter = [
  {
    path: 'budgets',
    name: 'CpeBudgets',
    component: () => import('@/views/CpeBudgets/Budgets/Index.vue'),
    meta: {
      key: 'cpe_budgets'
    },
  },
]

const CpeBudgetsRouter = [
  {
    path: 'cpe_budgets',
    name: 'cpe_budget',
    redirect: 'CpeBudgets',
    meta: {
      key: 'cpe_budgets'
    },
    children: CpeBudgetsChilrensRouter
  }
]

export {CpeBudgetsRouter}
